<template>
    <div class="offerDetail" :class="!isWillOffer?'yesOfferedDiv':'noOfferedDiv'">
        <div class="sectionHeader" ref="getheight" v-if="showHeader">
            <div class="isFixed">
                <mainHeader class="mainHeader" @logout="logoutClick"></mainHeader>
            </div>
        </div>
        <div ref="getheight2">
            <offerDetailTop :showHeader="showHeader" :backTitle="'采购信息'"></offerDetailTop>
        </div>
        <offerDetailUserinfo :data="wantBuyDetails"></offerDetailUserinfo>
        <offerDetailList :data="wantBuyDetails" :topHeight="topHeight"></offerDetailList>
        <offerDetailDemand :data='wantBuyDetails'></offerDetailDemand>
        <offerDetailMore :data='wantBuyDetails'></offerDetailMore>
        <div class="baojia-btn" :style="{height:isIphoneX?'75px':'65px'}" v-if="isWillOffer">
            <button class="ben-btn-r" @click="willOffer">立即报价</button>
        </div>
        <back-to-top transitionName="fade" :customStyle="myBackToTopStyle"  :iconColor="myBackToTopStyleIconColor"
            :visibilityHeight="300" :backPosition="0">
        </back-to-top>
        <Login :show="showLogin" @click="loginPopClick"></Login>
    </div>
</template>
<script>
import mainHeader from '@/view/header'
import offerDetailTop from './components/offerDetailTop.vue'
import offerListCom from './components/offerListCom.vue'
import backToTop from './components/backToTop'
import offerDetailUserinfo from "./components/offerDetailUserinfo.vue"
import offerDetailList from "./components/offerDetailList.vue"
import offerDetailDemand from "./components/offerDetailDemand.vue"
import offerDetailMore from "./components/offerDetailMore.vue"
import Login from '../shopping/goods/pop-login.vue'
import { createNamespacedHelpers, mapGetters, mapActions as mapOtherActions, mapState as mapOtherState, } from "vuex";
const { mapActions, mapState } = createNamespacedHelpers("procurement");
export default {
    name:'informDetail',
    inject: ['reload'], // 界面刷新
    components: {
        mainHeader,offerDetailTop,offerListCom,backToTop,offerDetailUserinfo,offerDetailList,offerDetailDemand,offerDetailMore,
        Login
    },
    data () {
        return {
            isLogin : false,
            showLogin: false,
            id : '',
            topHeight : 0,
            isWillOffer : false,
            showHeader : false,
            tabHeight : 0,
            myBackToTopStyle: {
                    'right': '15px',
                    'bottom': '90px',
                    'width': '40px',
                    'height': '40px',
                    'border-radius': '20px',
                    'line-height': '40px', 
                    'background': '#C41335',
                    "color" : "#ffffff"
                },
            myBackToTopStyleIconColor : {
                "color" : "#ffffff"
            },
            isIphoneX : false,
        }
    },
    created () {
        this.id = this.$route.query.id;
        console.log(this.utils.isIphoneOrPc())
        if(this.utils.isIphoneOrPc()=='pc'){
            // location.href = "http://192.168.166.97:7006/shoplist?id="+this.id
            location.href = "https://www.zxzx119.com/shoplist?id="+this.id
            
        }
        if (this.$route.query.isApp == 1 || localStorage.getItem('isApp') == 1||this.$route.query.isApp == 2 || localStorage.getItem('isApp') == 2) {
      this.showHeader = false
    } else {
      this.showHeader = true
    }
    if (parseInt(this.$route.query.isApp) === 1 || parseInt(localStorage.getItem('isApp')) === 1 || parseInt(this.$route.query.isApp) === 2 || parseInt(localStorage.getItem('isApp')) === 2) {
      var _this = this
      window['androidTabHeight'] = (result) => {
        _this.androidTabHeight(result)
      }
      if (this.utils.isIphone() === true) {
        this.androidTabHeight('0')
      } else {
        this.androidTabHeight(window.zxzx.getNavigationBarHeight())
      }
    }
    this.isIphoneX = this.utils.isIphoneX() ;
    console.log("isIphone12or13:",this.isIphoneX)
    },
    computed:{
        ...mapState(['wantBuyDetails']),
    },
    methods: {
        ...mapActions(["getWantBuyDetails"]),
        androidTabHeight (value) {
      // 设置android 模态导航条
      if (this.utils.isIphone() === true) {
        if (this.utils.isIphoneX() === true) {
          this.tabHeight = 20
        } else {
          this.tabHeight = 0
        }
      } else {
        this.tabHeight = parseInt(value)
      }
    },
        willOffer(){
            if(this.utils.loginState()==0){
                this.showLogin = true
            }else{
                this.$router.push({path:"willOffer",query:{id:this.id}})
            }
        },
        getLoading(){
            this.getWantBuyDetails({id:this.id}).then(res=>{
                if((res.data.wantBuyAndDetails.tails.status==1||res.data.wantBuyAndDetails.tails.status==2)&&res.data.isOffered==0){
                    this.isWillOffer =  true
                }else{
                    this.isWillOffer = false
                }

            })
        },
        
        logoutClick: function () { // 退出登录  刷新界面
            this.reload()
        },
        loginPopClick: function (type) { // 0 隐藏 1 登录成功 2 注册 3 忘记密码
            // console.log('type：', type)
            this.showLogin = false

            if (type === 1) {
                this.isLogin = 1
                this.logoutClick()
            }
            if (type === 2) {
                this.$router.push({ path: 'register' })
            }
            if (type === 3) {
                this.$router.push({ path: 'retrieve' })
            }
        },
        checkLogin () {
          this.utils.get(this.companyUrl + '/ent/json', null, res => {
                localStorage.setItem('userinfo', JSON.stringify(res.data))
            })
        }
    },
    mounted () {
        this.getLoading()
        var _this = this
        this.utils.isUserLogin(function (login) {
        if (login === 0) {
            _this.isLogin = 0
        } else {
            _this.isLogin = 1
            _this.checkLogin()
        }
        
        })
        let height= this.showHeader? this.$refs.getheight.offsetHeight : 0; 
        let height2= this.$refs.getheight2.offsetHeight; 
        this.topHeight = height+height2;
    },
}

</script>


<style lang='scss' scoped>
.yesOfferedDiv{
    padding-bottom: 10px;
    
}
.noOfferedDiv{
    padding-bottom: 75px;
}
.offerDetail{
    background: #eee;
    .baojia-btn{
        background: #fff;
        height: 65px;
        padding: 10px 15px;
        margin-top:10px ;position:fixed;
        bottom: 0;
        width: 100%;
        z-index: 10;
        >button{
            width: 100%;
            font-size: 15px;
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/view/procurement/offerDetail.vue